import { render, staticRenderFns } from "./add4.vue?vue&type=template&id=7d56ac21&scoped=true&"
import script from "./add4.js?vue&type=script&lang=js&"
export * from "./add4.js?vue&type=script&lang=js&"
import style0 from "./add4.css?vue&type=style&index=0&id=7d56ac21&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d56ac21",
  null
  
)

export default component.exports